import { render, staticRenderFns } from "./Diccionario.vue?vue&type=template&id=1e14070e&scoped=true"
import script from "./Diccionario.vue?vue&type=script&lang=js"
export * from "./Diccionario.vue?vue&type=script&lang=js"
import style0 from "./Diccionario.vue?vue&type=style&index=0&id=1e14070e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e14070e",
  null
  
)

export default component.exports